import { StyledPreviewDataTag } from "../../preview";
import { StyledPatientContainer } from "../styled";

/**
 * Static stand-ins for order data. These are never editable — on the real page
 * they come from the order, so they are labelled as sample data.
 */
export const previewPatient = {
  accountName: "General Hospital",
  patientName: "Jane Doe",
  address: "street av test, SLC, UT 12345",
};

export function PreviewPatientDetails() {
  return (
    <>
      <p className="text-xs font-medium line-height-3">Notice from</p>
      <p className="text-lg font-medium line-height-3 font-semibold title mb-2">
        {previewPatient.accountName}
      </p>
      <p className="text-sm font-normal line-height-3 mb-3">
        Regarding your appointment for:
      </p>

      <StyledPatientContainer>
        <StyledPreviewDataTag>PREVIEW DATA</StyledPreviewDataTag>

        <p className="text-xs line-height-3 font-medium mb-1">PATIENT</p>
        <h2 className="font-semibold text-lg highlighted line-height-3 mb-1">
          {previewPatient.patientName}
        </h2>
        <p className="text-xs line-height-3 font-medium mb-2 mt-2">
          VISIT DETAILS
        </p>
        <p className="text-sm line-height-2 font-normal">
          {previewPatient.address}
        </p>
      </StyledPatientContainer>
    </>
  );
}
